const timesheetServiceServiceName = "/TimesheetCompletion";

export function timesheetCompletionService(http) {
    return {
        // getPersonnelPermissionCount: async (personnelCode) => {
        //     return await http.post(timesheetServiceServiceName + "/PersonnelPermissionCountAsync", { personnelCode })
        // },
        getPersonnelPermissionCount: async (personnelCode, month, year) => {
            return await http.post(timesheetServiceServiceName + "/PersonnelPermissionCountAsync", { personnelCode, month, year })
        }

    }
}
